(function () {
  /* Best Selling / YMAL / collection / search / featured grids */
  const ROOT_SELECTOR =
    '.ymal-section .related-products-carousel, .ymal-cards-scope, #product-grid, .product-grid';

  function getSectionsToFetch() {
    return ['cart-icon-bubble', 'cart-drawer'];
  }

  function applySections(sections) {
    if (!sections) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.getSectionsToRender) {
      cartDrawer.getSectionsToRender().forEach((section) => {
        const sectionHtml = sections[section.id];
        if (!sectionHtml) return;
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement) return;
        sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(sectionHtml, section.selector);
      });
      cartDrawer.classList.remove('is-empty');
      const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
      overlay?.addEventListener('click', cartDrawer.close.bind(cartDrawer));
    }

    const bubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
    if (bubbleSection && sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const inner = html.querySelector('.shopify-section');
      if (inner) bubbleSection.innerHTML = inner.innerHTML;
    }

    cartDrawer?.setHeaderCartIconAccessibility?.();
    cartDrawer?.bindPremiumDrawerUi?.();

    const countBadge = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (countBadge) {
      countBadge.classList.add('pbr-count-pop');
      window.setTimeout(() => countBadge.classList.remove('pbr-count-pop'), 450);
    }
  }

  function refreshCartSections() {
    const sectionIds = getSectionsToFetch().join(',');
    const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionIds)}`;

    return fetch(url)
      .then((r) => r.json())
      .then((sections) => {
        applySections(sections);
        return sections;
      })
      .catch(() => {});
  }

  function getButtonTextEl(button) {
    return button.querySelector('.ymal-card__atc-text') || button;
  }

  function setButtonLabel(button, text) {
    const el = getButtonTextEl(button);
    if (el) el.textContent = text;
  }

  function isButtonLocked(button) {
    return button?.classList.contains('is-locked');
  }

  function lockButtonSuccess(button, options = {}) {
    if (!button) return;
    const { animate = true } = options;
    const successLabel = button.dataset.successLabel || 'ADDED';
    setButtonLabel(button, successLabel);
    button.classList.remove('is-loading', 'is-animating');
    button.classList.add('is-success', 'is-locked');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.dataset.ymalBusy = 'false';
    if (animate) {
      button.classList.add('is-success-pop');
      window.setTimeout(() => button.classList.remove('is-success-pop'), 400);
    }
  }

  function unlockButton(button) {
    if (!button || button.dataset.ymalBusy === 'true') return;
    button.classList.remove('is-success', 'is-locked', 'is-loading', 'is-animating', 'is-success-pop');
    button.disabled = false;
    button.removeAttribute('aria-disabled');
    setButtonLabel(button, button.dataset.defaultLabel || 'ADD TO CART');
  }

  function syncButtonsFromCart(cartPayload) {
    const apply = (cart) => {
      const qtyByVariant = new Map();
      (cart?.items || []).forEach((item) => {
        const id = String(item.variant_id || item.id);
        qtyByVariant.set(id, (qtyByVariant.get(id) || 0) + (item.quantity || 0));
      });

      document.querySelectorAll('[data-ymal-atc]').forEach((button) => {
        if (button.dataset.soldOut === 'true') return;
        const variantId = String(button.dataset.variantId || '');
        if (!variantId) return;
        const inCart = (qtyByVariant.get(variantId) || 0) > 0;
        if (inCart) {
          lockButtonSuccess(button, { animate: false });
        } else {
          unlockButton(button);
        }
      });
    };

    if (
      cartPayload &&
      Array.isArray(cartPayload.items) &&
      typeof cartPayload.item_count === 'number'
    ) {
      apply(cartPayload);
      return;
    }

    fetch(`${routes.cart_url}.js`)
      .then((r) => r.json())
      .then(apply)
      .catch(() => {});
  }

  function onCartSync(event) {
    if (event?.type === 'visibilitychange' && document.visibilityState !== 'visible') return;
    if (event?.source === 'ymal-card-form') return;
    syncButtonsFromCart(event?.cartData);
  }

  function addToCart(button) {
    if (!button || button.dataset.ymalBusy === 'true' || isButtonLocked(button)) return;
    if (button.classList.contains('is-loading')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.dataset.ymalBusy = 'true';
    button.classList.add('is-animating');
    window.requestAnimationFrame(() => {
      button.classList.remove('is-animating');
      button.classList.add('is-loading');
      setButtonLabel(button, button.dataset.loadingLabel || 'Adding...');
    });

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: {
              _add_source: 'You may also like',
            },
          },
        ],
        sections: getSectionsToFetch().join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          button.dataset.ymalBusy = 'false';
          button.classList.remove('is-loading');
          setButtonLabel(button, button.dataset.defaultLabel || 'ADD TO CART');
          const form = button.closest('ymal-card-form');
          const wrapper = form?.querySelector('.product-form__error-message-wrapper');
          const msg = form?.querySelector('.product-form__error-message');
          if (wrapper && msg) {
            wrapper.hidden = false;
            msg.textContent = response.description || 'Could not add to cart';
          }
          syncButtonsFromCart();
          return;
        }

        lockButtonSuccess(button, { animate: true });

        const cartDrawer = document.querySelector('cart-drawer');
        if (response.sections && cartDrawer?.renderContents) {
          cartDrawer.renderContents(response);
        } else {
          refreshCartSections().then(() => cartDrawer?.open?.());
        }

        fetch(`${routes.cart_url}.js`)
          .then((r) => r.json())
          .then((cart) => {
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'ymal-card-form',
                cartData: cart,
              });
            }
            syncButtonsFromCart(cart);
          })
          .catch(() => {
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ymal-card-form' });
            }
            syncButtonsFromCart();
          });
      })
      .catch((err) => {
        console.error(err);
        button.dataset.ymalBusy = 'false';
        button.classList.remove('is-loading');
        setButtonLabel(button, button.dataset.defaultLabel || 'ADD TO CART');
      });
  }

  function bindForm(form) {
    if (form.dataset.ymalBound === 'true') return;
    form.dataset.ymalBound = 'true';

    form.addEventListener('submit', (evt) => {
      evt.preventDefault();
      const button = form.querySelector('[data-ymal-atc]');
      addToCart(button);
    });
  }

  function scan(root) {
    root.querySelectorAll('.ymal-card__form-inner[data-type="add-to-cart-form"]').forEach(bindForm);
    syncButtonsFromCart();
  }

  function init() {
    scan(document);

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartSync);
    }
    document.addEventListener('visibilitychange', onCartSync);
    window.addEventListener('pageshow', onCartSync);

    const roots = document.querySelectorAll(ROOT_SELECTOR);
    const observeTarget = roots.length ? null : document.body;
    const targets = roots.length ? roots : observeTarget ? [observeTarget] : [];

    targets.forEach((el) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            scan(node);
          });
        });
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
